import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux';
import Hashids from 'hashids';
import shortid from 'shortid';
import 'react-dropdown/style.css'

// import Header from '../components/Header/Header.js'
import Button from '../components/Button/Button.js'
import UserDropdown from '../components/UserDropdown/UserDropdown.js'

import UserSettingsDisplayNameForm from '../components/UserSettingsDisplayNameForm/UserSettingsDisplayNameForm.js'
import UserSettingsDefaultSettingsForm from '../components/UserSettingsDefaultSettingsForm/UserSettingsDefaultSettingsForm.js'
import UserSettingsDefaultWorkspaceForm from '../components/UserSettingsDefaultWorkspaceForm/UserSettingsDefaultWorkspaceForm.js'
import UserSettingsEmailForm from '../components/UserSettingsEmailForm/UserSettingsEmailForm.js'
import UserSettingsEmailVerifiedForm from '../components/UserSettingsEmailVerifiedForm/UserSettingsEmailVerifiedForm.js'
import UserSettingsPasswordForm from '../components/UserSettingsPasswordForm/UserSettingsPasswordForm.js'
import UserSettingsMFAForm from '../components/UserSettingsMFAForm/UserSettingsMFAForm.js'
import UserSettingsPendingInvites from '../components/UserSettingsPendingInvites/UserSettingsPendingInvites.js'
import UserSettingsDeleteAccountForm from '../components/UserSettingsDeleteAccountForm/UserSettingsDeleteAccountForm.js'

import UserSettingsStripePortalLauncher from '../components/UserSettingsStripePortalLauncher/UserSettingsStripePortalLauncher.js'

import UserSettingsUpgradeToProForm from '../components/UserSettingsUpgradeToProForm/UserSettingsUpgradeToProForm.js'
// import UserSettingsCancelProForm from '../components/UserSettingsCancelProForm/UserSettingsCancelProForm.js'
// import UserSettingsInvoice from '../components/UserSettingsInvoice/UserSettingsInvoice.js'
// import UserSettingsPastInvoices from '../components/UserSettingsPastInvoices/UserSettingsPastInvoices.js'
// import UserSettingsBillingStatusForm from '../components/UserSettingsBillingStatusForm/UserSettingsBillingStatusForm.js'
// import UserSettingsPaymentMethodsForm from '../components/UserSettingsPaymentMethodsForm/UserSettingsPaymentMethodsForm.js'

import TeamSettingsNameForm from '../components/TeamSettingsNameForm/TeamSettingsNameForm.js'
import TeamSettingsSignatureForm from '../components/TeamSettingsSignatureForm/TeamSettingsSignatureForm.js'
import TeamSettingsThemeForm from '../components/TeamSettingsThemeForm/TeamSettingsThemeForm.js'
// import TeamSettingsDomainsTable from '../components/TeamSettingsDomainsTable/TeamSettingsDomainsTable.js'
import TeamSettingsMembersTable from '../components/TeamSettingsMembersTable/TeamSettingsMembersTable.js'
// import TeamSettingsAddRemoveSeats from '../components/TeamSettingsAddRemoveSeats/TeamSettingsAddRemoveSeats.js'
import TeamSettingsAddMemberForm from '../components/TeamSettingsAddMemberForm/TeamSettingsAddMemberForm.js'
// import TeamSettingsInvoice from '../components/TeamSettingsInvoice/TeamSettingsInvoice.js'
// import TeamSettingsPastInvoices from '../components/TeamSettingsPastInvoices/TeamSettingsPastInvoices.js'
// import TeamSettingsBillingInfoForm from '../components/TeamSettingsBillingInfoForm/TeamSettingsBillingInfoForm.js'
// import TeamSettingsBillingStatusForm from '../components/TeamSettingsBillingStatusForm/TeamSettingsBillingStatusForm.js'
// import TeamSettingsPaymentMethodsForm from '../components/TeamSettingsPaymentMethodsForm/TeamSettingsPaymentMethodsForm.js'
import TeamSettingsDeleteForm from '../components/TeamSettingsDeleteForm/TeamSettingsDeleteForm.js'
import TeamSettingsLeaveForm from '../components/TeamSettingsLeaveForm/TeamSettingsLeaveForm.js'
// import TeamSettingsMigrateForm from '../components/TeamSettingsMigrateForm/TeamSettingsMigrateForm.js'

import TeamSettingsStripePortalLauncher from '../components/TeamSettingsStripePortalLauncher/TeamSettingsStripePortalLauncher.js'
import TeamSettingsReactivateForm from '../components/TeamSettingsReactivateForm/TeamSettingsReactivateForm.js'

import {
  tryToFetchMyTeams
} from '../actions/actions.export'

var pf_config = require('../pf_config.json');

var hashids = new Hashids('k100p');

class Settings extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

  }

  componentWillMount(){
    const { user, dispatch } = this.props;

    if(!user.isLoggedIn){
      dispatch(push('/404'));
    }
  }

  componentDidMount(){
    window.document.title = "Settings - Pattycake";

    // const { dispatch, team } = this.props;

    // if(!team.tryingToFetchmyTeams){
    //   dispatch(tryToFetchMyTeams());
    // }
  }

  componentDidUpdate(){
  }

  generateTeamChildren(t){
    const { dispatch, user, team, memberManager } = this.props;

    let hashedID = hashids.encode(t.id);

    let members = memberManager.cache[t.id] || [];

    let urlpiece = t.isFirm ? "firm" : "team";

    return [
      // {
      //   hideIf: t.myRole != 'admin' || t.isFirm,
      //   icon: "birthday-cake text-danger",
      //   display: <span className="text-danger">Migrate Your Team</span>,
      //   url: "/settings/" + urlpiece + "/" + hashedID + "/upgrade-to-firms",
      //   description: <span className="text-danger">We've deprecated Pattycake Teams and launched a cheaper way to get your firm access.</span>,
      //   content: <TeamSettingsMigrateForm id={t.id}/>
      // },
      {
        hideIf: t.myRole != 'admin' || !t.subscription_ended,
        icon: "rocket text-success",
        display: <span className="text-success">Reactivate Your Firm</span>,
        url: "/settings/" + urlpiece + "/" + hashedID + "/reactivate",
        description: <span className="text-success">Restart your subscription to empower your team.</span>,
        content: <TeamSettingsReactivateForm id={t.id}/>
      },
      {
        hideIf: t.myRole != 'admin',
        icon: "cogs",
        display: "Configure Pattycake",
        url: "/settings/" + urlpiece + "/" + hashedID + "/config",
        description: "Change default Pattycake settings and appearance.",
        disabled: t.subscription_ended,
        children: [
          {
            hideIf: t.myRole != 'admin',
            icon: "address-card",
            display: "Change " + (t.isFirm ? "Firm" : "Team") + " Name",
            url: "/settings/" + urlpiece + "/" + hashedID + "/config/name",
            content: <TeamSettingsNameForm id={t.id}/>
          },
          {
            hideIf: t.myRole != 'admin',
            icon: "signature",
            display: "Edit .PAT Signature",
            url: "/settings/" + urlpiece + "/" + hashedID + "/config/signature",
            content: <TeamSettingsSignatureForm id={t.id}/>
          },
          {
            hideIf: t.myRole != 'admin',
            icon: "palette",
            display: "Change theme",
            url: "/settings/" + urlpiece + "/" + hashedID + "/config/theme",
            content: <TeamSettingsThemeForm id={t.id}/>
          }
        ]
      },
      {
        hideIf: t.myRole != 'admin',
        icon: (t.overstaffed && !t.subscription_ended) ? "users text-danger" : "users",
        display: (t.overstaffed && !t.subscription_ended) ? <span className="text-danger">Manage Members</span> : "Manage Members",
        url: "/settings/" + urlpiece + "/" + hashedID + "/members",
        description: (t.overstaffed && !t.subscription_ended) ? <span className="text-danger">Your firm is currently locked due to being overstaffed for its current license quota.</span> : "Add, remove, and manage access for your firm's team members and license.",
        disabled: t.subscription_ended,
        children: [
          {
            hideIf: t.myRole != 'admin' || t.isEnterprise,
            icon: "user-plus",
            display: "Add Members",
            url: "/settings/" + urlpiece + "/" + hashedID + "/members/add",
            disabled: t.subscription_ended,
            content: <TeamSettingsAddMemberForm id={t.id}/>
          },
          {
            hideIf: t.myRole != 'admin',
            icon: t.overstaffed ? "user-plus text-danger" : "user-plus",
            display: t.overstaffed ? <span className="text-danger">Manage Members</span> : "Manage Members",
            url: "/settings/" + urlpiece + "/" + hashedID + "/members/access",
            content: <TeamSettingsMembersTable id={t.id}/>
          },
          // {
          //   hideIf: t.myRole != 'admin' || !t.isFirm || t.isEnterprise,
          //   icon: "chair-office",
          //   display: "Add & Remove Seats",
          //   url: "/settings/" + urlpiece + "/" + hashedID + "/members/seats",
          //   disabled: t.subscription_ended,
          //   content: <TeamSettingsAddRemoveSeats id={t.id} key={t.seats}/>
          // }
        ]
      },
      {
        hideIf: t.myRole != 'admin',
        icon: t.delinquent ? "exclamation-triangle text-danger" : "dollar-sign",
        display: t.delinquent ? <span className="text-danger">Billing</span> : "Billing",
        url: "/settings/" + urlpiece + "/" + hashedID + "/billing",
        description: t.delinquent ? <span className="text-danger">You have a past due invoice.</span> : "Manage your billing settings, payment methods, and more via Stripe's billing portal.",
        content: <TeamSettingsStripePortalLauncher id={t.id}/>
        // children: [{
        //     hideIf: t.myRole != 'admin',
        //     display: "Billing Email",
        //     icon: "envelope",
        //     url: "/settings/" + urlpiece + "/" + hashedID + "/billing/email",
        //     content: <TeamSettingsBillingInfoForm id={t.id}/>
        //   },
        //   {
        //     hideIf: t.myRole != 'admin',
        //     display: "Status",
        //     icon: "info-circle",
        //     url: "/settings/" + urlpiece + "/" + hashedID + "/billing/status",
        //     content: <TeamSettingsBillingStatusForm id={t.id}/>
        //   },
        //   {
        //     hideIf: t.myRole != 'admin',
        //     display: "Upcoming Invoice",
        //     icon: "file-invoice-dollar",
        //     url: "/settings/" + urlpiece + "/" + hashedID + "/billing/upcoming-invoice",
        //     content: <TeamSettingsInvoice id={t.id}/>
        //   },
        //   {
        //     hideIf: t.myRole != 'admin',
        //     display: t.delinquent ? <span className="text-danger">Past Invoices</span> : "Past Invoices",
        //     icon: t.delinquent ? "exclamation-triangle text-danger" : "file-invoice-dollar",
        //     url: "/settings/" + urlpiece + "/" + hashedID + "/billing/past-invoices",
        //     content: <TeamSettingsPastInvoices id={t.id}/>
        //   },
        //   {
        //     hideIf: t.myRole != 'admin',
        //     display: "Payment Methods",
        //     icon: "credit-card",
        //     url: "/settings/" + urlpiece + "/" + hashedID + "/billing/payment-methods",
        //     content: <TeamSettingsPaymentMethodsForm id={t.id}/>
        //   },
        //   {
        //     hideIf: t.myRole != 'admin',
        //     display: "Cancel Subscription",
        //     icon: "exclamation-triangle",
        //     url: "/settings/" + urlpiece + "/" + hashedID + "/billing/cancel",
        //     content: <p>To cancel your subscription, visit the <Link to={"/settings/" + urlpiece + "/" + hashedID + "/delete"}>Delete Firm</Link> section.</p>
        //   },
        // ]
      },
      {
        icon: 'door-open',
        display: "Leave " + (t.isFirm ? "Firm" : "Team"),
        url: "/settings/" + urlpiece + "/" + hashedID + "/leave",
        description: "Leaving means losing access to this " + (t.isFirm ? "firm's" : "team's") + " private patterns and creation abilities.",
        disabled: t.subscription_ended,
        content: <TeamSettingsLeaveForm id={t.id}/>
      },
      {
        hideIf: t.myRole != 'admin',
        icon: "exclamation-triangle",
        display: "Delete " + (t.isFirm ? "Firm" : "Team"),
        url: "/settings/" + urlpiece + "/" + hashedID + "/delete",
        description: "Permenantly delete this " + (t.isFirm ? "firm" : "team") + " and its data.",
        content: <TeamSettingsDeleteForm id={t.id}/>
      }
    ]
  }

  render(){
    const { team, user, dispatch } = this.props;

    var page = this.props.match.params.page;
    if(page){
      page = '/' + page;
    } else {
      page = '';
    }

    var menuTree = [
      {
        display: (user.roles.pro ? "Your Pro Account" : user.roles.enterprise ? "Your Info" : "Your Personal Account"),
        divider: true
      },
      {
        icon: "user",
        display: user.display_name,
        delinquent: user.delinquent,
        url: "/settings/my-account",
        children: [
          {
            icon: "award text-award",
            display: "Upgrade to Pro",
            url: "/settings/my-account/upgrade-to-pro",
            description: "Unlock dozens of additional patterns, templates, and powerful editing features.",
            hideIf: user.roles.pro || user.roles.enterprise,
            content: <UserSettingsUpgradeToProForm/>
          },
          {
            icon: "info-circle",
            display: "Managed Account Notice",
            url: "/settings/my-account/managed-account-notice",
            description: "Learn about your managed account.",
            hideIf: !user.roles.enterprise,
            content: <div className="mega-pad">
              <p>
                Because you joined your organization's Pattycake Enterprise, your account is now <span className="text-700">managed</span> by your organization.
              </p>
              <p>
                You no longer has the ability to join firms, other enterprises, or save patterns outside of your organization. Adminstrators of your organization's enterprise account have the ability edit your access level to the enterprise, including deleting your account entirely.
              </p>
              <p>
                If you have questions or believe you are seeing this message in error, please <Link to="/contact">contact us.</Link>
              </p>
              <p>
                The Pattycake Team 🎂
              </p>
            </div>
          },
          {
            icon: "cogs",
            display: "Configure Pattycake",
            url: "/settings/my-account/config",
            description: "Change default Pattycake settings.",
            children: [
              {
                display: "Profile Info",
                icon: "user",
                url: "/settings/my-account/config/profile-info",
                content: <UserSettingsDisplayNameForm/>
              },
              {
                display: "Default .PAT Format",
                icon: "file-powerpoint",
                url: "/settings/my-account/config/pat",
                content: <UserSettingsDefaultSettingsForm/>
              },
              {
                display: "Default Workspace",
                icon: "chair-office",
                url: "/settings/my-account/config/default-workspace",
                content: <UserSettingsDefaultWorkspaceForm/>,
                hideIf: user.roles.enterprise,
                hidden: Object.keys(team.cache).length == 0
              }
            ]
          },
          {
            icon: "user-lock",
            display: "Security",
            url: "/settings/my-account/security",
            description: "Manage your password and two-factor authentication settings.",
            children: [
              {
                icon: "mask",
                display: "Password",
                url: "/settings/my-account/security/password",
                description: "Change your password",
                content: <UserSettingsPasswordForm/>
              },
              {
                icon: "key",
                display: "Two-Factor Authentication",
                url: "/settings/my-account/security/2fa",
                description: "Manage your 2FA settings.",
                content: <UserSettingsMFAForm/>
              }
            ]
          },
          {
            icon: "envelope",
            display: "Email",
            url: "/settings/my-account/email",
            description: "Manage your email preferences, addresses changes, and verification.",
            children: [
              {
                display: "Change Email Address",
                icon: "envelope",
                url: "/settings/my-account/email/change",
                content: <UserSettingsEmailForm/>
              },
              {
                display: "Verify Email Address",
                icon: "badge-check",
                url: "/settings/my-account/email/verify",
                content: <UserSettingsEmailVerifiedForm/>
              }
            ]
          },
          {
            icon: user.delinquent ? "exclamation-triangle text-danger" : "dollar-sign",
            display: user.delinquent ? <span className="text-danger">Billing</span> : "Billing",
            url: "/settings/my-account/billing",
            description: "Manage your subscription settings, payment methods, and more via Stripe's billing portal.",
            hideIf: !user.stripe_customer_id,
            content: <UserSettingsStripePortalLauncher/>
            // children: [
            //   {
            //     display: "Status",
            //     icon: "info-circle",
            //     url: "/settings/my-account/billing/status",
            //     content: <UserSettingsBillingStatusForm/>
            //   },
            //   {
            //     display: "Current Invoice",
            //     icon: "file-invoice-dollar",
            //     url: "/settings/my-account/billing/current-invoices",
            //     content: <UserSettingsInvoice/>
            //   },
            //   {
            //     display: user.delinquent ? <span className="text-danger">Past Invoices</span> : "Past Invoices",
            //     icon: user.delinquent ? "exclamation-triangle text-danger" : "file-invoice-dollar",
            //     url: "/settings/my-account/billing/past-invoices",
            //     content: <UserSettingsPastInvoices/>
            //   },
            //   {
            //     display: "Payment Methods",
            //     icon: "credit-card",
            //     url: "/settings/my-account/billing/payment-methods",
            //     content: <UserSettingsPaymentMethodsForm/>
            //   },
            //   {
            //     display: "Cancel Subscription",
            //     icon: "exclamation-triangle",
            //     url: "/settings/my-account/billing/cancel-pro",
            //     content: <UserSettingsCancelProForm/>
            //   },
            // ]
          },
          {
            icon: "bell",
            display: "Pending Invitations",
            url: "/settings/my-account/pending-invitations",
            description: "Accept invitations to Pattycake Firms or join your organization's Enterprise.",
            hideIf: user.roles.enterprise,
            content: <UserSettingsPendingInvites/>
          },
          {
            icon: "exclamation-triangle",
            display: "Delete Account",
            url: "/settings/my-account/delete",
            description: "Delete your Pattycake account.",
            content: <UserSettingsDeleteAccountForm/>
          }
        ]
      }
    ]


    let teamCount = 0;
    for(var i in team.cache){
      if(!team.cache[i].isEnterprise && !team.cache[i].isFirm){
        teamCount++;
      }
    }

    if(teamCount > 0){
      menuTree.push({
        display: "Your Teams",
        divider: true
      })

      for(var i in team.cache){
        if(!team.cache[i].isEnterprise && !team.cache[i].isFirm){
          menuTree.push({
            icon: "users",
            display: team.cache[i].display_name,
            delinquent: team.cache[i].delinquent,
            url: "/settings/team/" + hashids.encode(team.cache[i].id),
            children: this.generateTeamChildren(team.cache[i])
          })
        }
      }
    }

    if(!user.roles.enterprise){
      menuTree.push({
        display: "Your Firms",
        divider: true
      })

      for(var i in team.cache){
        if(!team.cache[i].isEnterprise && team.cache[i].isFirm){
          menuTree.push({
            icon: "users",
            display: team.cache[i].display_name,
            delinquent: team.cache[i].delinquent,
            subscription_ended: team.cache[i].subscription_ended,
            overstaffed: team.cache[i].overstaffed,
            url: "/settings/firm/" + hashids.encode(team.cache[i].id),
            children: this.generateTeamChildren(team.cache[i])
          })
        }
      }

      menuTree.push({
        icon: "plus",
        display: "Create a Firm",
        url: "/pattycake-for-firms-sign-up"
      })
    }


    let path = [
      {
        display: "Settings",
        url: "/settings"
      }
    ];

    let currentMenuTree;
    let currentSubMenuTree;
    let currentContent;

    let pathname = window.location.pathname;

    if(pathname.includes('/settings/firm/purchase-success')){
      let latestTeam;
      for(var i in team.cache){
        if(!latestTeam) latestTeam = i;

        if(team.cache[i].created_on > team.cache[latestTeam].created_on) latestTeam = i;
      }
      if(latestTeam){
        pathname = pathname.replace('purchase-success', hashids.encode(team.cache[latestTeam].id));
      }
    }

    for(var i in menuTree){
      if(pathname.indexOf(menuTree[i].url) == 0){
        currentMenuTree = menuTree[i];
        path.push(menuTree[i]);

        if(menuTree[i].content) currentContent = menuTree[i].content;

        for(var ii in menuTree[i].children){
          if(pathname.indexOf(menuTree[i].children[ii].url) == 0 && !menuTree[i].children[ii].hideIf){
            path.push(menuTree[i].children[ii]);
            currentSubMenuTree = menuTree[i].children[ii];

            if(menuTree[i].children[ii].content) currentContent = menuTree[i].children[ii].content;

            for(var iii in menuTree[i].children[ii].children){
              if(pathname.indexOf(menuTree[i].children[ii].children[iii].url) == 0 && !menuTree[i].children[ii].children[iii].hideIf){
                path.push(menuTree[i].children[ii].children[iii]);

                if(menuTree[i].children[ii].children[iii].content) currentContent = menuTree[i].children[ii].children[iii].content;
              }
            }
          }
        }
      }
    }


    const generateChild = (m, i) => {
      if(m.hideIf) return;

      if(m.disabled) return <div key={i} className={"settings-content-child-menu-item settings-content-child-menu-item-disabled"}>
        {
          m.icon &&
          <div className="settings-content-child-menu-item-icon">
            <i className={"fal fa-fw fa-" + m.icon}/>
          </div>
        }
        <div className="settings-content-child-menu-item-body">
          <div className="settings-content-child-menu-item-title">{m.display}</div>
          {
            m.description &&
            <div className="settings-content-child-menu-item-description">{m.description}</div>
          }
        </div>
      </div>; 

      return <Link to={m.url} key={i} className={"settings-content-child-menu-item " + (pathname.indexOf(m.url) == 0 ? "settings-content-child-menu-item-active" : "")}>
        {
          m.icon &&
          <div className="settings-content-child-menu-item-icon">
            <i className={"fal fa-fw fa-" + m.icon}/>
          </div>
        }
        <div className="settings-content-child-menu-item-body">
          <div className="settings-content-child-menu-item-title">{m.display}</div>
          {
            m.description &&
            <div className="settings-content-child-menu-item-description">{m.description}</div>
          }
        </div>
      </Link>
    }



    
    return <div className="content-wrapper">
      {
        (team.tryingToFetchmyTeams) && 
        <div className="dead-center dead-center-themed">
          <i className="fas fa-spinner-third fa-spin fa-3x"/>
        </div>
      }
      <div className="home">
        <div className="settings">
          <div className="settings-menu">
            
            <div className="settings-menu-header">
              <nobr>
                <Link to="/pat" className="brand-font">
                  <span className="brand-space-fix">P</span>attycake
                </Link>
              </nobr>
            </div>

            <div className="settings-menu-links">
              {
                menuTree.map((m, i)=>{
                  if(m.divider){
                    return <div className="settings-menu-link-divider" key={i}>{m.display}</div>
                  }


                  return <Link key={i} to={m.url} className={"settings-menu-link " + (pathname.indexOf(m.url) == 0 ? "settings-menu-link-active" : "")}>
                    <span>{
                      m.subscription_ended ? <i className="fas fa-do-not-enter fa-fw settings-menu-link-icon"/> 
                      :
                      (m.delinquent || m.overstaffed) ? <i className="fas fa-exclamation-triangle text-danger fa-fw settings-menu-link-icon"/> 
                      : 
                      <i className={"fas fa-" + m.icon + " fa-fw settings-menu-link-icon"}/>} {m.display}</span>
                  </Link>
                })
              }
            </div>

            
            <div className="settings-menu-footer">
              <span>by <a href="http://theschool.studio" target="_blank" rel="noopener noreferrer">school</a> + <a href="https://not.yet.digital" target="_blank" rel="noopener noreferrer">not.yet.digital</a></span>
            </div>

          </div>
          <div className="settings-content">
            <div className="settings-content-header flex-split">
              <div className="">
                {
                  path.map((p,i)=>{
                    
                    return <Link key={i} to={p.url} className="settings-content-header-location">
                      {i > 0 && <span> <i className="far fa-angle-right fa-fw settings-content-header-location-splitter"/> </span>}

                      <span className={(i == path.length - 1 ? "settings-content-header-location-child" : "settings-content-header-location-parent")}>{p.display}</span>
                    </Link>
                  })
                }
              </div>
              <div className="list-right">
                <Link to="/new/drawing" className="list-item button-link d-none d-md-block">
                  <Button display={<span>Launch Pattycake &nbsp;<i className="fad fa-angle-double-right"/></span>} color="primary" size="medium"/>
                </Link>
                <UserDropdown dropdownOnly={true}/>
              </div>  
            </div>
            <div className="settings-content-body">
              {
                (currentMenuTree && !currentMenuTree.disabled) && 
                <div className="settings-content-body-column settings-content-child-menu">
                  <div className="inner-overflow">
                    {
                      currentMenuTree.children.map(generateChild)
                    }
                  </div>
                </div>
              }
              {
                (currentSubMenuTree && currentSubMenuTree.children && !currentSubMenuTree.disabled) &&
                <div className="settings-content-body-column settings-content-child-menu">
                  <div className="inner-overflow">
                    {
                      currentSubMenuTree.children.map(generateChild)
                    }
                  </div>
                </div>
              }
              <div className="settings-content-body-container">
                <div className="inner-overflow settings-content-body-container-inner">
                  {
                    currentContent ? currentContent : <div className="translucent"><i className="far fa-arrow-alt-left"/>&nbsp; Please choose a setting to configure.</div>
                  }
                </div>
              </div>
            </div>
          </div>  
        </div>  
      </div>
    </div>
  }
}


const mapStateToProps = (state) => {
  const { 
    team, user, memberManager
  } = state;

  return {
    team, user, memberManager
  }
}

export default connect(mapStateToProps)(Settings);


// WEBPACK FOOTER //
// ./src/routes/Settings.js